import { Appender } from 'aurelia-logging';
import * as rg4js from 'raygun4js';

export class RaygunErrorLogger implements Appender {
	constructor(private raygunApiKey: string, private applicationVersion: string, private userEmail: string) {
	}

	activate(): void {
		rg4js('setVersion', this.applicationVersion);
		rg4js('options', {
			allowInsecureSubmissions: true,
			ignoreAjaxAbort: true,
			ignoreAjaxError: true,
			debugMode: true,
			ignore3rdPartyErrors: false,
			wrapAsynchronousCallbacks: true,
			disableErrorTracking: false,
			disablePulse: true
		});
		rg4js('enableCrashReporting', true);
		rg4js('apiKey', this.raygunApiKey);
		rg4js('onBeforeSend', (errorReport) => {
			errorReport.Details.Tags = ['frontend'];
			return errorReport;
		});
		rg4js('setUser', {
			identifier: this.userEmail,
			isAnonymous: false
		});
	}

	debug(logger: Object, ...rest: any[]): void {
		// no-op
	}

	info(logger: Object, ...rest: any[]): void {
		// no-op
	}

	warn(logger: Object, ...rest: any[]): void {
		// no-op
	}

	error(logger: Object, ...rest: any[]): void {
		if (!rest || rest.length < 1) {
			return;
		}

		const error = rest[0];
		rg4js('send', { error: error });
	}
}
